@for (element of elements; track element) {
  <ng-container rsResolve [element]="element"></ng-container>
  <!-- TODO: Do we want to use a break for this? -->
}
